/**
 * A frame's top row on a surface that owns its chrome (`chrome: "none"`,
 * the wall's Pinned tiles): only a calm title line in Satoshi, with an
 * optional muted note beside it and an optional link to the full view at
 * its end (mockup `.pin-h .lnk`). No drag handle.
 */
import { Button } from "@/components/ui";
import { cn } from "@/lib/cn";

interface FrameCalmTitleAction {
  label: string;
  onClick: () => void;
  testId: string;
}

export function FrameCalmTitle({
  title,
  note,
  action,
  className,
  "data-testid": testId,
}: {
  title: string;
  note?: string;
  action?: FrameCalmTitleAction;
  /** An opened window's frame sets the title's inset to its body's. */
  className?: string;
  "data-testid"?: string;
}) {
  return (
    <div
      className={cn(
        "flex min-w-0 shrink-0 items-baseline gap-[0.5em] px-[1.2em] pt-[1em] font-display text-[1.2em] font-medium tracking-[-0.01em] text-primary",
        className,
      )}
      data-testid={testId}
      data-frame-title="calm"
    >
      <span className="min-w-0 truncate">{title}</span>
      {note && (
        <span className="shrink-0 font-sans text-[0.7em] font-normal tracking-normal text-muted">
          {note}
        </span>
      )}
      {action && (
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="ml-auto h-[1.9em] shrink-0 self-center bg-card-line px-[0.75em] font-sans text-[0.62em] font-medium tracking-normal text-card-body hover:text-card-ink"
          onClick={action.onClick}
          data-testid={action.testId}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
